import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import { actions } from '../../../redux/modules/reports/jobs/financialSchedulesReportActions'
import { DatePicker, Button, Form, Checkbox, AutoComplete, Input, Icon, Spin } from 'antd'
import _ from 'lodash'
import { convertToOption } from '../../../util'
import ListItems from '../../../components/reports/jobs/financial-schedules/ListItem'
import moment from 'moment'
import queryString from 'qs'
import config from '../../../config'

const { API_BASE } = config
const { RangePicker } = DatePicker

const propTypes = {}
const FormItem = Form.Item
const CheckboxGroup = Checkbox.Group

class FinancialSchedulesReportContainer extends Component {
  constructor(props) {
    super(props)

    const filter = [
      moment('2018-01-01', 'YYYY-MM-DD').startOf('month'),
      moment(new Date(), 'YYYY-MM-DD').endOf('month')
    ]

    this.state = {
      filter,
      checkedTypeList: [],
      checkAllType: false,
      plainTypeOptions: [
        'Repair',
        'New Construction',
        'Speciality',
        'Modernization',
        'Maintenance/Service',
        'Material Sale'
      ],
      checkedDatesList: [],
      checkAllDates: false,
      plainDatesOptions: [
        'Executed Contract',
        'Contract Expiration',
        'AIA Due Day',
        'AIA Expected Pay Day',
        'Monthly Invoice Day'
      ]
    }

    // get organization list
    this.props.financialSchedulesReportGetJobList({})
  }

  onChange = (date, dateString) => {
    this.setState({
      filter: dateString
    })
  }

  onChangeTypeCheckboxGroup = checkedTypeList => {
    this.setState({
      checkedTypeList,
      checkAllType: checkedTypeList.length === this.state.plainTypeOptions.length
    })
  }

  onChangeStatusCheckboxGroup = checkedDatesList => {
    this.setState({
      checkedDatesList,
      checkAllDates: checkedDatesList.length === this.state.plainDatesOptions.length
    })
  }

  applyFilter = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }
      this.props.financialSchedulesReportGetFullReport({ filters: values })
    })
  }

  handleJobSearch = _.debounce(value => {
    this.props.financialSchedulesReportGetJobList({
      filters: {
        name: value
      }
    })
  }, 500)

  onCheckAllTypeChange = e => {
    const { form } = this.props

    form.setFieldsValue({
      types: e.target.checked ? this.state.plainTypeOptions : []
    })

    this.setState({
      checkedTypeList: e.target.checked ? this.state.plainTypeOptions : [],
      checkAllType: e.target.checked
    })
  }

  onCheckAllDatesesChange = e => {
    const { form } = this.props

    form.setFieldsValue({
      statuses: e.target.checked ? this.state.plainDatesOptions : []
    })

    this.setState({
      checkedDatesList: e.target.checked ? this.state.plainDatesOptions : [],
      checkAllDates: e.target.checked
    })
  }

  printReport = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }
      const params = _.omit(values, 'date_range')

      if (values.date_range[0] && values.date_range[1]) {
        params.startDate = moment(values.date_range[0]).format('YYYY-MM-DD')
        params.endDate = moment(values.date_range[1]).format('YYYY-MM-DD')
      }

      const qs = queryString.stringify(params)
      const url = `${API_BASE}/api/reports/jobs/financial-schedules/print?${qs}`
      window.open(url, '_blank')
    })
  }

  render() {
    const { getFieldDecorator } = this.props.form

    const jobListData = _.get(this.props, 'financialSchedulesReportActions.jobList.data')
    const loadingJobList = _.get(this.props, 'financialSchedulesReportActions.loadingJobList')

    const loadingFullReport = _.get(this.props, 'financialSchedulesReportActions.loadingFullReport')
    const fullReport = _.get(this.props, 'financialSchedulesReportActions.fullReport.data')
    return (
      <div style={{ marginTop: 20, marginBottom: 20 }}>
        <div className="row">
          <div className="col-10">
            <h3>Financial Schedule</h3>
          </div>
          <Button icon="printer" onClick={() => this.printReport()} />
        </div>
        <Form layout="vertical">
          <div className="row">
            <div className="col-4">
              <div className="row">
                <div className="col-10">
                  <FormItem label="Select the date range:">
                    {getFieldDecorator('date_range', {
                      rules: [
                        {
                          required: true,
                          message: 'You must enter a value'
                        }
                      ],
                      initialValue: this.state.filter
                    })(<RangePicker onChange={this.onChange} />)}
                  </FormItem>
                </div>
              </div>
              <div className="row">
                <div className="col-10">
                  <Spin spinning={loadingJobList}>
                    <FormItem label="Job">
                      {getFieldDecorator('job_id', {})(
                        <AutoComplete
                          onChange={this.handleJobSearch}
                          dataSource={convertToOption(jobListData)}
                          filterOption={(inputValue, option) =>
                            option.props.children
                              .toUpperCase()
                              .indexOf(inputValue.toUpperCase()) !== -1
                          }
                          placeholder="Search for a Job"
                        >
                          <Input
                            suffix={<Icon type="search" className="certain-category-icon" />}
                          />
                        </AutoComplete>
                      )}
                    </FormItem>
                  </Spin>
                </div>
              </div>
            </div>
            <div className="col-8">
              <FormItem label="Types:">
                {getFieldDecorator('types', {
                  initialValue: this.state.checkedTypeList
                })(
                  <CheckboxGroup
                    options={this.state.plainTypeOptions}
                    onChange={this.onChangeTypeCheckboxGroup}
                    className="open-container-row"
                  />
                )}
              </FormItem>
              <div style={{ borderTop: '1px solid #E9E9E9' }}>
                <Checkbox
                  indeterminate={this.state.indeterminate}
                  onChange={this.onCheckAllTypeChange}
                  checked={this.state.checkAllType}
                >
                  Check all
                </Checkbox>
              </div>
            </div>
            <div className="col-4" />
            <div className="col-8">
              <FormItem label="Dates:">
                {getFieldDecorator('dates', {
                  initialValue: this.state.checkedDatesList
                })(
                  <CheckboxGroup
                    options={this.state.plainDatesOptions}
                    onChange={this.onChangeStatusCheckboxGroup}
                    className="open-container-row"
                  />
                )}
              </FormItem>
              <div style={{ borderTop: '1px solid #E9E9E9' }}>
                <Checkbox
                  indeterminate={this.state.indeterminate}
                  onChange={this.onCheckAllDatesesChange}
                  checked={this.state.checkAllDates}
                >
                  Check all
                </Checkbox>
              </div>
            </div>
          </div>
          <Button type="primary" onClick={() => this.applyFilter()}>
            Submit
          </Button>
        </Form>
        <div className="row" style={{ marginTop: 20, marginBottom: 20 }}>
          <div className="col-12">
            <ListItems
              fullReport={fullReport}
              loadingFullReport={loadingFullReport}
              checkedDateList={this.state.checkedDatesList}
            />
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({ financialSchedulesReportActions, authentication }, ownProps) => ({
  financialSchedulesReportActions,
  authentication
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(Object.assign({}, actions), dispatch)
})

FinancialSchedulesReportContainer.propTypes = propTypes
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Form.create()(FinancialSchedulesReportContainer))
)



// WEBPACK FOOTER //
// ./src/containers/reports/jobs/FinancialSchedulesReportContainer.js